/**
 * Thousands separators for antd InputNumber.
 *
 * The formatter used across these forms was
 *   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
 * which groups digits in the *decimal* part too — a management fee of 0.0075
 * rendered as "0.0,075". Group the integer part only and leave the decimals
 * alone.
 */
export const groupThousands = value => {
  if (value === undefined || value === null || value === '') return '';
  const [int, ...rest] = String(value).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return rest.length ? `${grouped}.${rest.join('.')}` : grouped;
};

/** Strips the separators back off before the value reaches the form. */
export const parseThousands = value =>
  value === undefined || value === null
    ? value
    : String(value).replace(/,/g, '');
